export const createLegendPayload = (chartRendering: any) => {
    const hiddenLegendKeys = ['alarms', 'mode']; // Metrics to hide from legend
    const payload: any[] = [];

    chartRendering.chartElementsConfig.lines.forEach((lineProps: any) => {
        if (lineProps.dataKey && !hiddenLegendKeys.includes(String(lineProps.dataKey))) {
            payload.push({
                value: lineProps.name,
                type: 'line',
                id: lineProps.key,
                color: lineProps.stroke,
            });
        }
    });

    return payload;
};